import { IMParticleUserIdentity } from './types';

export const createMparticleIdentity = (
  email: string,
  customerid: string
): IMParticleUserIdentity => {
  return { email, customerid };
};
